import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/overstockInventory'
import Component from 'components/Inventory/SelectOverstockItemInventory'

export default createListModalContainer({ actions })(Component)
